import React, { useState, useEffect } from 'react';
import { Image, RichText, Text, getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import GraphQLData from '../../lib/GraphQLData';
import { loader as gqlLoader } from 'graphql.macro';
import compose from 'compose-function';
import { withTranslation } from 'react-i18next';

const FAQsQuery = gqlLoader('./FAQs.graphql');
var fields = {};
const FAQsInner = (props) => {
  const items = props?.faqs?.trustfactors?.faqTabs?.targetItems || [];

  const [activeTab, setActiveTab] = useState('');
  const [visibleItems, setVisibleItems] = useState(5);
  const [showLoadMore, setShowLoadMore] = useState(true);

  useEffect(() => {
    if (items?.length > 0) {
      setActiveTab(items[0].menuTitle.value);
    }
  }, [items]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setVisibleItems(5);
    setShowLoadMore(true);
  };

  const handleLoadMore = () => {
    const nextVisibleItems = visibleItems + 5;

    setVisibleItems(nextVisibleItems);

    if (nextVisibleItems >= activeTabQuestionsCount) {
      setShowLoadMore(false);
    }
  };

  const activeTabQuestionsCount =
    items.find((category) => category.menuTitle.value === activeTab)?.questions.length || 0;

  const [activeAccordion, setActiveAccordion] = useState(0);

  const handleAccordionToggle = (index) => {
    setActiveAccordion(index === activeAccordion ? -1 : index);
  };

  return (
    <section
      className="faq_section faq_section_cat abcd_faq span-1-anm"
      id={fields?.StickyNavId?.value}
    >
      {(fields?.backgroundImage?.value?.src || fields?.bgImageMobile?.value?.src) && (
        <div className="component-bg-img-setup">
          <picture>
            <img
              src={fields?.backgroundImage?.value?.src}
              alt={fields?.backgroundImage?.value?.alt}
              className="desktop-img"
              width={fields?.backgroundImage?.value?.width}
              height={fields?.backgroundImage?.value?.height}
            />
            <img
              src={fields?.bgImageMobile?.value?.src}
              alt={fields?.bgImageMobile?.value?.alt}
              className="responsive-img"
              width={fields?.bgImageMobile?.value?.width}
              height={fields?.bgImageMobile?.value?.height}
            />
          </picture>
        </div>
      )}
      <div className="faq_header_wrapper">
        <h2 className="section-heading heading-flex ">
          <span className="" data-aos="fade-up" data-aos-duration="2000">
            <RichText field={fields?.heading} editable={true} />
          </span>
        </h2>
      </div>
      <div className="faq_acc_wrapper">
        <div className="magic_line_tabs_filter_faq">
          <ul className="faq_tab_Wrapper magic_line_faq_menu" id="faq_pills-tab" role="tablist">
            {items?.map((category, index) => {
              return (
                <li className="nav-item" role="presentation" key={index}>
                  <button
                    className={`nav-link ${
                      activeTab === category?.menuTitle?.value ? 'active' : ''
                    }`}
                    onClick={() => handleTabClick(category?.menuTitle?.value)}
                    id={`faq_pills-${category?.menuTitle?.value.toLowerCase()}`}
                    data-bs-toggle="pill"
                    data-bs-target={`#${category?.menuTitle?.value.toLowerCase()}`}
                    type="button"
                    role="tab"
                    aria-controls={`faq_pills-${category?.menuTitle?.value.toLowerCase()}`}
                    aria-selected={activeTab === category?.menuTitle?.value}
                  >
                    <Text field={category?.menuTitle} editable={true} />
                  </button>
                </li>
              );
            })}
            <div className="magic-line_faq"></div>
          </ul>
        </div>
        <div className="tab-content faq_Wrapper_tab_div" id="faq_pills-tabContent">
          {items?.map((category) => (
            <div
              key={category?.id}
              className={`tab-pane fade ${
                activeTab === category?.menuTitle?.value ? 'show active' : ''
              }`}
              id={`faq_pills-${category?.menuTitle?.value.toLowerCase()}`}
              role="tabpanel"
              aria-labelledby={`faq_pills-${category?.menuTitle?.value.toLowerCase()}-tab`}
            >
              <div className="accordion" id={`tab${category?.id}_acc`}>
                {category?.questions.slice(0, visibleItems).map((question, index) => {
                  const themes = [
                    'support_yellow_theme',
                    'support_green_theme',
                    'warm_yellow_theme',
                    'dark_green_theme',
                  ];
                  const themeIndex = index % themes.length;
                  const isFirstItem = index === 0;
                  return (
                    <div
                      key={index}
                      className={`accordion-item faq_acc_item ${
                        fields?.hasBorderColor?.value ? themes[themeIndex] : ''
                      } ${isFirstItem ? 'border_red' : ''}`}
                    >
                      <h2 className="accordion-header" id={`heading${index + 1}_${category?.id}`}>
                        <button
                          className={`accordion-button accordion-button-p ${
                            index === activeAccordion ? '' : 'collapsed'
                          }`}
                          type="button"
                          onClick={() => handleAccordionToggle(index)}
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse${index + 1}_${category?.id}`}
                          aria-expanded={index === activeAccordion}
                          aria-controls={`collapse${index + 1}_${category?.id}`}
                        >
                          <Text field={question?.heading} editable={true} />{' '}
                          <em className="faq_chev_down faq_chev_down_m"></em>
                        </button>
                      </h2>
                      <div
                        id={`collapse${index + 1}_${category?.id}`}
                        className={`accordion-collapse faq_acc_collapse collapse ${
                          index === activeAccordion ? 'show' : ''
                        }`}
                        aria-labelledby={`heading${index + 1}_${category?.id}`}
                        data-bs-parent={`#tab${category?.id}_acc`}
                      >
                        <div className="accordion-body">
                          <RichText
                            tag="p"
                            className="accordion-p"
                            field={question?.description}
                            editable={true}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
          {activeTabQuestionsCount > 5 && showLoadMore && (
            <div className="faq_link text-center">
              <a
                className="header_border_btn drop_a"
                href="javascript:;"
                onClick={handleLoadMore}
                id="myBtn_load_more"
              >
                {props.t('LoadMore')} <em className="load_more_down" />
              </a>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default function FAQs(props) {
  fields = props.fields;
  const Wrapper = compose(
    withTranslation(),
    GraphQLData(FAQsQuery, {
      name: 'faqs',
      options: {
        variables: {
          datasource: props?.rendering?.dataSource ? props?.rendering?.dataSource : '',
        },
      },
    })
  )(FAQsInner);
  return <Wrapper />;
}
